import React, { useState } from 'react';

import { Box, Center } from '@chakra-ui/react';

import { Select, SelectedOptions } from 'components/DataEntry/Select';

import {
  OutlinedFormFieldComponentProps,
  OutlinedFormSelectField,
} from '../types';

import { FieldContainer } from './FieldContainer';

export const SelectField = ({
  field,
  styles,
}: OutlinedFormFieldComponentProps<OutlinedFormSelectField>) => {
  const showSelectedAtBottomOutside =
    field.selectProps?.showSelectedAtBottomOutside;
  const showMoreSelectedOptions =
    field.selectProps?.showMoreSelectedOptions && showSelectedAtBottomOutside;
  const selected = Array.isArray(field.value) ? field.value : [];
  const selectedOptionsLimit = field.selectProps?.selectedOptionsLimit ?? 3;
  const [showAllSelectedOptions, setShowAllSelectedOptions] = useState(false);
  const visibleSelected = showAllSelectedOptions
    ? selected
    : selected.slice(0, selectedOptionsLimit);
  const hasHiddenSelectedOptions =
    showMoreSelectedOptions && selected.length > selectedOptionsLimit;

  return (
    <Box>
      <FieldContainer
        fieldStyles={field.styles}
        isDisabled={field.isDisabled}
        label={field.label}
        styles={styles}
      >
        <Box mt={1} {...styles?.value} {...field.styles?.value}>
          <Select
            showBorder={false}
            showClearIndicator={false}
            showIconInValueContainer={false}
            {...field.selectProps}
            menuPortalTarget={
              field.selectProps?.menuPortalTarget ??
              (typeof document !== 'undefined' ? document.body : undefined)
            }
            styles={{
              container: provided => ({
                ...provided,
                height: '28px',
              }),
              valueContainer: provided => ({
                ...provided,
                padding: 0,
              }),
              singleValue: provided => ({
                ...provided,
                color: 'black',
                margin: 0,
              }),
              ...field.selectProps?.styles,
            }}
            isDisabled={field.isDisabled}
            onChange={field.onChange}
            options={field.options}
            placeholder={field.placeholder}
            value={field.value}
          />
        </Box>
      </FieldContainer>
      {showSelectedAtBottomOutside && selected.length > 0 && (
        <Box mt={2}>
          <Box {...field.selectProps?.selectedOptionsStyles}>
            <SelectedOptions
              selected={visibleSelected}
              isDisabled={field.isDisabled || !field.onChange}
              styles={field.selectProps?.selectedOptionTagStyles}
              selectedOptionLabel={field.selectProps?.selectedOptionLabel}
              onRemove={option =>
                field.onChange?.(
                  selected.filter(
                    selectedOption => selectedOption.value !== option.value,
                  ),
                )
              }
            />
          </Box>
          {hasHiddenSelectedOptions && (
            <Center
              as="button"
              type="button"
              color="primary"
              fontSize="sm"
              onClick={() => setShowAllSelectedOptions(value => !value)}
              _hover={{ textDecoration: 'underline' }}
            >
              {showAllSelectedOptions ? 'show less' : 'show more'}
            </Center>
          )}
        </Box>
      )}
    </Box>
  );
};
